const SkeletonRegisterLead = () => {
  return (
    <div
      className="skeletonFormContact"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="skeletonFormRow">
        <div className="skeleton-input register-lead"></div>
      </div>

      <div className="skeletonBox recatpchaBox">
        <div
          className="skeleton-text"
          style={{
            width: '100%',
            height: '18px',
            maxWidth: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        />

        <div
          className="skeleton-text"
          style={{
            width: '100%',
            height: '18px',
            maxWidth: '45%',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        />
      </div>
      <div className="skeleton-button"></div>
    </div>
  );
};

export default SkeletonRegisterLead;
